import(/* webpackMode: "eager" */ "/home/runner/work/ai-chat-client/ai-chat-client/app/page.tsx");
